import SearchMixin from './mixin.js';

export default Vue.extend({
  mixins: [SearchMixin],

  props: {
    selectedUserIds: {
      type: Array,
      default() {
        return [];
      },
    },

    usersUrl: {
      type: String,
      default: '/admin/users',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    popoverPosition: {
      type: String,
      default: 'top',
    },
  },

  template: `
    <Popover :position='popoverPosition'
             :caret='false'
             :blockContent='true'
             :manualToggle='true'
             customClass='search-user'
             @triggerClicked='triggerClicked'
             @beforeClose='clearKeyword'
             ref='popoverVm'>
      <template slot='trigger'>
        <chip-input :chips='selectedItems'
                    :placeholder='placeholder'
                    @chipClicked='unselect'
                    @keywordChange='keywordChange'
                    ref='chipInput' />
      </template>
      <template slot='content'>
        <search-list :items='items'
                     @valueChanged='valueChanged'
                     :toggleFunc='toggleUser'
                     ref='searchListVm'>
          <template slot='option-template' slot-scope='{ item }'>
            <headimg :src='item.headimgurl' />
            <span>{{ item.name }}</span>
            <span class='content user-identifier'>{{ item.identifier }}</span>
            <i :class="selectedClass(item)" class='primary-text'></i>
          </template>
        </search-list>
      </template>
    </Popover>
  `,

  created() {
    this.initSelectedUsers();
  },

  methods: {
    setValue(ids) {
      if (_.isEmpty(ids)) {
        this.selectedItems = [];
      } else {
        this.initSelectedUsers(ids);
      }
    },

    initSelectedUsers(ids = this.selectedUserIds) {
      this.fetching = true;

      if (_.isEmpty(ids)) {
        this.selectedItems = [];
        this.fetching = false;
      } else {
        Skylark.Libs.Ajax.get(
          Skylark.Helpers.UrlHelper.generateUrlWithParams(this.usersUrl, { ids }),
          {
            success: (users) => {
              this.selectedItems = _.each(this._formatItems(users), (item) => { item._selected = true; });
            },
            complete: () => {
              this.fetching = false;
            },
          },
        );
      }
    },

    keywordChange(keyword) {
      this.updateKeyword(keyword);
      if (this.keyword) {
        this.$refs.popoverVm.open();
      }
    },

    triggerClicked(event) {
      if (event.target === this.$refs.chipInput.$refs.input.$el) {
        if (this.keyword) {
          this.$refs.popoverVm.open();
        } else {
          this.$refs.popoverVm.close();
        }
      }
    },

    unselect(user) {
      if (this.$refs.searchListVm) {
        this.$refs.searchListVm.unselect(user);
      } else {
        this.toggleUser(user);
      }
    },

    toggleUser(user) {
      user._selected = !user._selected;
      this.valueChanged(user);
    },
  },
});
